module.exports = "/images/blister-8.png";